module.exports = __webpack_public_path__ + "img/exercise_test.55f8c016.png";